<template>
  <div class="h-full w-full items-center flex justify-center login sm:mb-10">
    <div class="default-card-border mt-[102px] mx-4 rounded sm:my-7 sm:w-full w-[920px]">
      <div class="flex sm:flex-col">
        <login-form />
        <img
          alt="Login Image"
          class="flex-grow-0 flex-shrink-0 login__wrapper--image sm:hidden"
          src="@/assets/images/login-image.jpg"
        />
      </div>
      <div class="mx-6 my-2 text-right sm:absolute sm:mx-4 sm:my-4 sm:right-0 sm:text-sm">
        <a
          alt="Term of Service"
          class="no-underline mr-8"
          href="https://www.takeorder.tw/terms-of-service"
          target="_blank"
        >
          <span class="text-blue-400">
            使用條款
          </span>
        </a>
        <a
          alt="Privacy and Policy"
          class="no-underline"
          href="https://www.takeorder.tw/privacy-and-policy"
          target="_blank"
        >
          <span class="text-blue-400">
            隱私權政策
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login';

export default Login;
</script>

<style lang="scss" scoped>
@import 'Login';
</style>
